import { useParams } from 'react-router-dom';
import { findBlogBySlug, findProjectBySlug } from '../utils.js'
import { BlogTemplate } from '../components/BlogTemplate.js'

const BlogPostPage = () => {
  const { slug } = useParams();
  const post = findBlogBySlug(slug);

  if(!post) {
    return (
      <div className="blog-post-page">
        <h1>Post not found</h1>
        <p>The post you are looking for does not exist.</p>
      </div>
    );
  }

  let relatedProject = null;
  if(post.projectSlug) {
    relatedProject = findProjectBySlug(post.projectSlug);
  }

  return <BlogTemplate
    post={post}
    relatedProject={relatedProject}
  />;
}

export default BlogPostPage;